'use strict';

module.exports = html;

function html(node) {
  return node.value;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/html.js
// module id = 969
// module chunks = 95715928098905 168707334958949